import { useNavigate, useLocation } from 'react-router-dom';
import PATH from 'crono-fe-common/constants/path';
import TemplateType from 'crono-fe-common/types/enums/templateType';
import { TEMPLATE_PARAM_KEYS } from './navigationConstants';

export type UseCreateNewTemplateNavigationReturn = {
  showCreateModal: boolean;
  setShowCreateModal: (show: boolean, templateType?: TemplateType) => void;
  navigateToEdit: (id: number) => void;
};

export const useCreateNewTemplateNavigation =
  (): UseCreateNewTemplateNavigationReturn => {
    const navigate = useNavigate();
    const location = useLocation();

    const showCreateModal = location.pathname.startsWith(
      PATH.TEMPLATE_UPSERT_NEW,
    );

    const setShowCreateModal = (show: boolean, templateType?: TemplateType) => {
      if (show) {
        if (location.pathname === PATH.TEMPLATE_UPSERT_NEW) return;
        const search = templateType
          ? `?${TEMPLATE_PARAM_KEYS.templateType}=${templateType}`
          : '';
        navigate(`${PATH.TEMPLATE_UPSERT_NEW}${search}`);
      } else {
        navigate(PATH.TEMPLATES);
      }
    };

    const navigateToEdit = (id: number) => {
      navigate(`${PATH.TEMPLATE_UPSERT_NEW}/${id}`);
    };

    return {
      showCreateModal,
      setShowCreateModal,
      navigateToEdit,
    };
  };
